import { useEffect, useState } from "react"

export const getInitials = (name?: string | null) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}

const avatarColors = [
  "bg-foundation-orange-500",
  "bg-foundation-base-darkbase-dark-500",
  "bg-foundation-base-darkbase-dark-300",
  "bg-foundation-orange-300",
  "bg-foundation-calm-blue-300",
]

export const getStableAvatarColor = (seed?: string | number | null) => {
  const text = String(seed || "")
  const total = Array.from(text).reduce((sum, char) => sum + char.charCodeAt(0), 0)
  return avatarColors[total % avatarColors.length]
}

export function AvatarBubble({
  name,
  seed,
  avatarUrl,
  className,
}: {
  name?: string | null
  seed?: string | number | null
  avatarUrl?: string | null
  className?: string
}) {
  const [imageAvailable, setImageAvailable] = useState(Boolean(avatarUrl))
  useEffect(() => {
    setImageAvailable(Boolean(avatarUrl))
  }, [avatarUrl])

  const shouldShowAvatar = Boolean(avatarUrl && imageAvailable)
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white font-semibold text-white ${getStableAvatarColor(seed || name)} ${className || "h-7 w-7 text-[11px]"}`}
      title={name || undefined}
    >
      {shouldShowAvatar ? (
        <img
          src={avatarUrl || undefined}
          alt={name ? `${name} avatar` : "Profile avatar"}
          className="h-full w-full object-cover"
          onError={() => setImageAvailable(false)}
        />
      ) : (
        getInitials(name)
      )}
    </span>
  )
}
